import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	flowConfigBlockHeader: {
		background: colors.getPrimaryColor()
	},
	flowConfigBlockHeaderTitle: {
		fontWeight: "bolder",
		color: colors.gray[0],
		fontSize: "16px",
		padding: theme.spacing(1.5, 0, 1.5, 1.5)
	},
	flowTriggerInfo: {
		padding: theme.spacing(0)
	},
	blockHeaderTitle: {
		fontWeight: "bolder",
		color: colors.gray[0]
	},
	blockHeader: {
		background: colors.green[400]
	},
	createBlockText: {
		color: "rgba(73, 80, 87, 0.7)"
	},
	createBlockIcon: {
		width: theme.spacing(4),
		height: theme.spacing(4),
		color: "rgba(73, 80, 87, 0.7)"
	},
	createBlockContainer: {
		padding: theme.spacing(3),
		border: `1px dashed ${colors.gray[300]}`,
		borderRadius: 6
	},
	flowContent: {
		height: "calc(100% - 64px)",
		width: "100%",
		overflow: "hidden",
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		padding: 16
	},
	flowContainer: {
		overflow: "hidden",
		height: "calc(100% - 64px)",
		alignContent: "flex-start",
		marginTop: theme.spacing(-3)
	},
	flowZoomContainer: {
		cursor: "auto !important",
		width: "100%"
	},
	flowZoomContent: {
		flexWrap: "nowrap",
		overflowX: "hidden"
	},
	createTriggerContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50])
	},
	webhookInfoUrlBlock: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		borderRadius: theme.shape.borderRadius
	},
	saveButton: {
		fontSize: "14px",
		color: colors.gray[0],
		padding: theme.spacing(1, 2)
	},
	actionButton: {
		width: theme.spacing(4),
		height: theme.spacing(4)
	},
	listItemDataTime: {
		opacity: "0.5",
		fontSize: "12px",
		fontWeight: 400,
		color: colors.gray[700],
		marginRight: theme.spacing(4)
	},
	clockIcon: {
		width: theme.spacing(2),
		height: "16px",
		color: colors.gray[700],
		opacity: "0.5",
		marginRight: theme.spacing(1.25),
		marginTop: theme.spacing(0.25)
	},
	chatBotName: {
		fontSize: "18px",
		fontWeight: 600,
		lineHeight: "24px",
		color: colors.gray[700]
	},
	saveArea: {
		display: "flex",
		justifyContent: "flex-end"
	},
	dataTime: {
		display: "flex",
		alignItems: "center"
	},
	chatBotData: {
		display: "flex",
		alignItems: "center"
	},
	blockActiveChatBotFlowButton: {
		position: "absolute",
		zIndex: 9,
		left: "-2px",
		top: "-5px"
	},
	chatBotBlockIdentification: {
		position: "absolute",
		zIndex: 9,
		right: "24px",
		bottom: "12px"
	},
	blockItemContainer: {
		position: "relative"
	},
	permissionWarningChip: {
		backgroundColor: colors.yellow[100],
		color: colors.yellow[800],
		fontWeight: 600,
		borderRadius: theme.spacing(0.5),
		"& .MuiChip-icon": {
			color: colors.yellow[800]
		}
	}
}))

export default useStyles
